module.exports = __webpack_public_path__ + "static/img/The_Film_Button.b0ebe12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/The_Film_Button.png
// module id = 739
// module chunks = 1